{
  "properties": {
    "property": {
      "route": "",
      "path": "/"
    },
    "loanApp": {
      "route": "loan-app",
      "path": "/loan-app"
    },
    "consent": {
      "route": "consent",
      "path": "/consent"
    },
    "activeLoan": {
      "route": "active-loans",
      "path": "/active-loans"
    },
    "paidLoans": {
      "route": "paid-loans",
      "path": "/paid-loans"
    },
    "payment": {
      "route": "payment",
      "path": "/payment"
    },
    "mockupData": {
      "route": "mockup-data",
      "path": "/mockup-data"
    }
  },
  "activeLoans": {
    "payment": {
      "route": "payment",
      "path": "/active-loans/payment"
    }
  }
}